import appRoutes from '../../../infrastructure/constants/appRoutes';

const leavePageMessage = 'The configuration has not been saved. All changes will be lost';
const leavePageTitle = 'Unsaved changes';

const configIsWaitingApprovalMessage = "The config can't be edited until the request for release has been approved by an admin user.";
const configIsWaitingApprovalTitle = 'Config is readonly';

const unsafeRoutes = [
    appRoutes.ingestion.fieldDefinition,
    appRoutes.ingestion.details,
    appRoutes.ingestion.signoff
];

const isNavigationSafe = (route: string): boolean => !unsafeRoutes.includes(route);

export { leavePageMessage, configIsWaitingApprovalMessage, isNavigationSafe, configIsWaitingApprovalTitle, leavePageTitle };
